import { alpha, Box, styled } from '@mui/material';

const StyledBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  gap: theme.spacing(1.5),
  padding: theme.spacing(3),
  borderRadius: theme.spacing(0.5),
  border: `1px solid ${alpha(theme.palette.common.white, 0.1)}`,
  '& .DSIcon': {
    fontSize: theme.spacing(4),
  },
}));
export default StyledBox;
